/**
 * Default theme color values used when ThemeProvider hasn't loaded
 * backend theme configuration yet.
 *
 * These values are the SINGLE SOURCE OF TRUTH for fallback theme colors.
 * They match the CSS custom properties defined in src/styles/design-tokens.css
 *
 * IMPORTANT: Do NOT duplicate these values elsewhere. Import from here.
 */
export const THEME_COLOR_DEFAULTS = {
  background: {
    primary: '#0A0A0A',
    secondary: '#161717',
  },
  text: {
    primary: '#E9E9F0',
    secondary: '#CECECE',
  },
  brand: '#DBB958',
  success: '#00E23F',
  warning: '#FFA500',
  info: '#3B82F6', // Fixed from #0000FF - WCAG AA compliant
  error: '#D70708',
} as const;

/**
 * Flat map for backward compatibility with theme providers
 */
export const THEME_DEFAULTS_FLAT = {
  'background.primary': THEME_COLOR_DEFAULTS.background.primary,
  'background.secondary': THEME_COLOR_DEFAULTS.background.secondary,
  'text.primary': THEME_COLOR_DEFAULTS.text.primary,
  'text.secondary': THEME_COLOR_DEFAULTS.text.secondary,
  brand: THEME_COLOR_DEFAULTS.brand,
  success: THEME_COLOR_DEFAULTS.success,
  warning: THEME_COLOR_DEFAULTS.warning,
  info: THEME_COLOR_DEFAULTS.info,
  error: THEME_COLOR_DEFAULTS.error,
} as const;

export type ThemeColorDefaults = typeof THEME_COLOR_DEFAULTS;
